import { Box, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

import SupportHelpBox from "./SupportHelpBox";

const CartHelpPanel: React.FC = () => (
  <SpaceBetween size="m">
    <Box>
      <p>
        As you search for relevant clips in Mamba you can either download them
        directly or move them to your cart. Your cart is how you move results
        into an Iconik collection.
      </p>
      <h3>Managing your cart</h3>
      <ul>
        <li>Add items from the search results</li>
        <li>Remove items from cart</li>
        <li>Proceed to checkout when ready</li>
        <li>Cart items are persistent across sessions</li>
      </ul>
    </Box>
    <SupportHelpBox />
  </SpaceBetween>
);

export default CartHelpPanel;
